import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@readsavor/api-client';
import { useAuthStore, userQueryKeys } from '@readsavor/auth';
/**
 * Stable query keys for subscription-related data.
 */
export const subscriptionQueryKeys = {
    all: ['subscription'],
    state: () => [...userQueryKeys.all, ...subscriptionQueryKeys.all, 'state'],
};
/**
 * Fetches the current user's subscription state.
 * This query is enabled only when a valid session exists.
 */
export const useSubscriptionState = () => {
    const status = useAuthStore(state => state.status);
    const isInitializationComplete = useAuthStore(state => state.isInitializationComplete);
    const enabled = status === 'authenticated' && isInitializationComplete;
    return useQuery({
        queryKey: subscriptionQueryKeys.state(),
        queryFn: () => {
            return apiClient.subscription.getState();
        },
        // This query is only enabled after the initial session check is complete
        // and a valid session exists.
        enabled: enabled,
        staleTime: 5 * 60 * 1000, // 5 minutes
        // Add retry logic to handle the race condition on initial load
        retry: 3,
        retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 10000), // Exponential backoff
    });
};
//# sourceMappingURL=useSubscriptionState.js.map